import { motion } from 'framer-motion';
import { Ruler, Scissors, Shirt, Sparkles } from 'lucide-react';

const floatingIcons = [
  { className: 'floating-icon-cut', icon: Scissors, delay: 0, rotate: -10 },
  { className: 'floating-icon-measure', icon: Ruler, delay: 0.35, rotate: 8 },
  { className: 'floating-icon-shirt', icon: Shirt, delay: 0.65, rotate: -4 },
  { className: 'floating-icon-finish', icon: Sparkles, delay: 0.95, rotate: 10 },
];

function HeroVisual() {
  return (
    <motion.figure
      className="hero-photo-visual"
      aria-label="Tailoring fabric workspace"
      initial={{ opacity: 0, scale: 0.94, x: 32 }}
      animate={{ opacity: 1, scale: 1, x: 0 }}
      transition={{ duration: 0.75, ease: 'easeOut' }}
    >
      <motion.div
        className="hero-photo-mask hero-photo-mask-back"
        animate={{ y: [5, -5], rotate: -7 }}
        transition={{ duration: 5.4, ease: 'easeInOut', repeat: Infinity, repeatType: 'mirror' }}
      >
        <img src="/hero.jpg" alt="Saqar Al-Jazeera tailoring workspace" />
      </motion.div>
      <motion.div
        className="hero-photo-mask hero-photo-mask-front"
        animate={{ y: [-6, 6] }}
        transition={{ duration: 5, ease: 'easeInOut', repeat: Infinity, repeatType: 'mirror' }}
      >
        <img src="/hero2.jpg" alt="Saqar Al-Jazeera tailoring workspace" />
      </motion.div>
      {floatingIcons.map(({ className, delay, icon: Icon, rotate }) => (
        <motion.span
          className={`hero-floating-icon ${className}`}
          key={className}
          initial={{ opacity: 0, scale: 0.7 }}
          animate={{ opacity: 1, scale: 1, y: [-8, 8], rotate }}
          transition={{
            delay,
            duration: 4.5,
            ease: 'easeInOut',
            repeat: Infinity,
            repeatType: 'mirror',
          }}
          aria-hidden="true"
        >
          <Icon size={24} strokeWidth={1.8} />
        </motion.span>
      ))}
      <div className="hero-photo-glow" aria-hidden="true" />
    </motion.figure>
  );
}

export default HeroVisual;
